import PageLayout from "@/components/PageLayout";
import DeliverySection from "@/components/DeliverySection";
import SEO from "@/components/SEO";

export default function DeliveryPage() {
  return (
    <PageLayout>
      <SEO
        title="Delivery & Shipping — Bangalore, Pan-India & Worldwide | Mutha Paras & Co."
        description="Same-day Bangalore delivery, 4-day South India dispatch, pan-India shipping via VRL Logistics, and international delivery via FedEx/DHL. Free delivery above Rs. 50,000."
        path="/delivery"
      />
      <DeliverySection />
    </PageLayout>
  );
}
